import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RaiseAComplaintComponent } from './raise-a-complaint/raise-a-complaint.component';
const routes: Routes = [
  {
    path: '',
    component: RaiseAComplaintComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComplaintFormRoutingModule { }
